<div class="news-detail-modal" [ngStyle]="(translate.currentLang=='ar') && {'direction': 'rtl', 'text-align': 'start'}">

  <div class="row">
    <!-- <h5 mat-dialog-title class="col-md-11" class="text-muted">
      {{new.DATE_STAMP|date:'medium' }}
    </h5> -->
    <h5 mat-dialog-title class="col-md-12 text-color-theme">
      <div class="
        d-flex flex-xl-row flex-lg-row flex-md-row flex-sm-row flex-column  
        justify-content-xl-between justify-content-lg-between justify-content-md-between justify-content-sm-between justify-content-start 
        align-items-xl-center align-items-lg-center align-items-md-center align-items-sm-center align-items-start 
      ">
        <div class="text-muted">{{new.DATE_STAMP|date:'medium' }}</div>
        <div class="news-type-badge rounded-pill" [ngStyle]="getColor(new.SEC_ID)">
          {{(translate.currentLang=='en')?new.SECTION:new.SECTION_ARB}}
        </div>
      </div>
      <br>
      {{ (translate.currentLang == 'en')? new.HEADING : new.ARB_HEADING}}
    </h5>
    <!-- <h5 mat-dialog-title class="col-md-11 text-color-theme" *ngIf="translate.currentLang == 'ar'">
      <span class="text-muted">{{new.DATE_STAMP|date:'medium' }}</span><br>
      {{new.ARB_HEADING}}
    </h5> -->

  </div>

  <mat-dialog-content>
    <div *ngIf="new.SHORT_DESC != null" class="text-color-theme">
      {{new.SHORT_DESC}}
    </div>
    <br>
    <div class="col-md-11" *ngIf="translate.currentLang == 'en'" class="text-color-theme">
      {{new.CONTENT}}
    </div>
    <div *ngIf="translate.currentLang == 'ar'" class="text-color-theme">
      {{new.ARB_CONTENT}}
    </div>

    <br>
    <div *ngIf="new.AttachmentUrl && new.AttachmentUrl.length>0" class="text-muted">{{"attachments"|translate}}:</div>
    <br>
    <div class="row">
      <div *ngFor="let attachment of new.AttachmentUrl; let i = index" class="mx-2">
        <div class="news-type-badge rounded-pill col" style="cursor:pointer;"
          (click)="openAttachment(attachment)" [ngStyle]="getColor(3)">
          {{'news-attachment-link' | translate}}
          {{i+1}}
        </div>
      </div>
    </div>

  </mat-dialog-content>

</div>